import Panel from "../Shared/Panel"

export default Panel.extend`
  background: rgba(0, 0, 0, 0.3);
  min-height: 140px;
  flex-basis: 140px;
  width: 100%;
  display: flex;
  flex-direction: row;
  margin: 36px 0 32px 0;
`



// WEBPACK FOOTER //
// ./src/Kiosk/LocationsModal/LocationList.js